import { gunterzBold } from '@/theme/fonts';
import { Box, Card, Grid, Image, Stack, Title } from '@mantine/core';
import { CharacterEquipCard } from './CharacterEquipCard';
import { EquipButton } from './EquipButton';
import { accessories, bodyEquip } from './data';
export const VipCharacterCard: React.FC = () => {
  return <Box mt={20}>
      <Card bg="var(--navbar-bg-color)" p={{
      base: 10,
      sm: 40
    }} radius={5} pos="relative">
        <Image w={{
        sm: 768,
        md: '80%'
      }} h={{
        sm: '40%',
        md: 'auto'
      }} visibleFrom="sm" pos="absolute" left={{
        sm: '-110px',
        md: 0
      }} top={{
        sm: '-40px',
        md: 0
      }} src="/assets/profile/character-bg.png" alt="background" style={{
        zIndex: 1,
        objectFit: 'contain'
      }} />

        <Grid style={{
        zIndex: 2
      }}>
          <Grid.Col span={{
          base: 12,
          md: 3
        }} order={{
          base: 2,
          md: 1
        }}>
            <Stack>
              {bodyEquip.map(item => <CharacterEquipCard key={item.part} {...item} />)}
            </Stack>
          </Grid.Col>
          <Grid.Col span={{
          base: 12,
          md: 6
        }} order={{
          base: 1,
          md: 2
        }} mt={{
          base: 20,
          sm: 0
        }}>
            <Stack w={{
            base: '100%',
            sm: 426
          }} mx="auto" gap={32}>
              <Title fz={20} tt="uppercase" ta="center" c="var(--text-dark)" className={gunterzBold.className}>
                your prime orb
              </Title>
              <Box>
                <Image src="/assets/profile/character.png" alt="character" />
              </Box>
            </Stack>
          </Grid.Col>
          <Grid.Col span={{
          base: 12,
          md: 3
        }} order={3}>
            <Stack>
              {accessories.map(item => <CharacterEquipCard key={item.part} {...item} />)}

              <Box mt={76}>
                <EquipButton />
              </Box>
            </Stack>
          </Grid.Col>
        </Grid>
      </Card>
    </Box>;
};